/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Duration from './duration';
import DurationDetail from './duration-detail';
import DurationUpdate from './duration-update';
import DurationDeleteDialog from './duration-delete-dialog';

const DurationRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Duration />} />
    <Route path="new" element={<DurationUpdate />} />
    <Route path=":id">
      <Route index element={<DurationDetail />} />
      <Route path="edit" element={<DurationUpdate />} />
      <Route path="delete" element={<DurationDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DurationRoutes;
